import { t } from "i18next";
import React from "react";
import {DataSourceStatus} from "../../../constants/DataSource/DataSourceStatus";
import {YML} from "../../DataSources/Items/YML/YML";
import {GoogleSheet} from "../../DataSources/Items/GoogleSheet/GoogleSheet";
import {Warehouse} from "../../DataSources/Items/Warehouse/Warehouse";
import {DmitrovkaResantagroupRu} from "../../DataSources/Items/DmitrovkaResantagroupRu";
import {RequestIntegration} from "../../DataSources/Items/RequestIntegration";
import ImportProductsConflictSourceDiffsResolve from "../../Task/NeedReaction/ImportProductsConflictSourceDiffsResolve";

export interface INeedReaction {
    type: string,
    data: Object[],
    isReacted: boolean
}

interface INeedReactionProps {
    notificationId: number,
    reactions: {
        [key: string]: INeedReaction
    }
}

const NeedReaction: React.FC<INeedReactionProps> = ({notificationId, reactions}) => {

    const renderItem = (i: INeedReaction, k: number) => {
        switch (i.type) {
            case 'hasSourceDiffs':
                return <div key={k} className={`mt-4`}><ImportProductsConflictSourceDiffsResolve taskId={notificationId} data={i}/></div>;
        }
    };

    return (
        <div style={{maxWidth: "100%", whiteSpace: "break-spaces", wordBreak: "break-word"}}>
            <hr className={'my-3'}/>
            {Object.values(reactions).map(renderItem)}
        </div>
    )

}

export default NeedReaction;